<template>
	<!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
	<div class="user">
		<!--搜索表单-->
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="姓名">
					<el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="formInline.mobile" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-menu :default-active="formInline.status" class="el-menu-demo" mode="horizontal"
					@select="handleSelect">
					<el-menu-item index="all">全部（{{extend.all_count}}）</el-menu-item>
					<el-menu-item index="0">待审核（{{extend.await_count}}）</el-menu-item>
					<el-menu-item index="1">审核通过（{{extend.audited_count}}）</el-menu-item>
					<el-menu-item index="2">审核拒绝（{{extend.no_count}}）</el-menu-item>
				</el-menu>
			</div>
			<div class="video-tag" v-loading.fullscreen.lock="loading">
				<div class="video-tag-item" v-for="(item,index) in tableData" :key="index">
					<video :src="item.videoFile" :poster="item.vider_fengmian_image" controls class="video"
						width="100%" height="250px" style="border-radius: 10px;object-fit: cover;"
						v-if="item.type == 2"></video>

					<div class="slider" v-else-if="item.type == 1">
						<div class="slides">
							<img :src="obj" v-for="(obj,index1) in item.images" :key="index1" alt="" style="width: 100%;height: 250px;" />
						</div>
					</div>

					<div class="video-tag-title">
						<span style="font-weight: bold;" v-if="item.waiter">{{item.waiter.username}}</span>
						<span style="color: #909399;font-size: 14px;">(编号：{{item.dynamicId}})</span>
					</div>
					<span class="video-tag-rich">{{item.content}}</span>
					<el-row type="flex" justify="center" align="middle">
						<el-button :type="item.status==0?'primary':''" size="mini" :disabled="item.status!=0"
							@click="btnAudit(item)">{{item.status==0?'审核':'已审核'}}</el-button>
						<el-button type="danger" icon="el-icon-error" size="mini" @click="btnDel(item)">删除</el-button>
					</el-row>
					<div class="video-tag-label">
						<div class="video-tag-center">
							<i class="el-icon-user-solid"></i>
							<span>点赞{{item.dianzanNum}}</span>
						</div>
						<div class="video-tag-center">
							<i class="el-icon-star-off"></i>
							<span>收藏{{item.guanzhuNum}}</span>
						</div>
						<div class="video-tag-center">
							<i class="el-icon-chat-dot-square"></i>
							<span>评价{{item.pinglunNum}}</span>
						</div>
					</div>
				</div>
			</div>
			<!--分页-->
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
					:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
					:total="totalDataNumber"></el-pagination>
			</div>
		</div>
		<!--审核-->
		<el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
			<el-form :model="workerinfo" :rules="rules" ref="formName">
				<el-form-item label="是否允许" prop="status	">
					<el-radio v-model="workerinfo.status" :label="1">审核通过</el-radio>
					<el-radio v-model="workerinfo.status" :label="2">审核不通过</el-radio>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changestatus">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Technician from "@/api/technician.js";

	export default {
		data() {
			return {
				dialogVisible: false,
				/*是否加载完成*/
				loading: true,
				/*列表数据*/
				tableData: [],
				/*一页多少条*/
				pageSize: 15,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				/*横向表单数据模型*/
				formInline: {
					username: "",
					mobile: "",
					status: "all"
				},
				rules: {
					status: [{
						required: true,
						message: '请选择！',
						trigger: 'blur'
					}]
				},
				workerinfo: {
					status: null,
				},
				extend: {
					all_count: 0,
					audited_count: 0,
					await_count: 0,
					no_count: 0,
				}
			};
		},
		created() {
			/*获取列表*/
			this.getTableList();
		},
		methods: {
			// 审核
			btnAudit(row) {
				this.workerinfo.dynamic_id = row.dynamic_id
				this.dialogVisible = true
			},
			// 修改审核状态
			changestatus() {
				let that = this
				if (that.workerinfo.status) {
					Technician.audit({
						dynamic_id: that.workerinfo.dynamic_id,
						status: that.workerinfo.status
					}).then(data => {
						if (data.code == 1) {
							that.$message({
								type: 'success',
								message: data.msg
							});
						}
						self.loading = true;
						self.getTableList();
					});
				} else {
					console.log('选择', that.workerinfo);
				}

				this.dialogVisible = false
			},
			// 删除
			btnDel(row) {
				let self = this;
				self
					.$confirm("确定删除该记录吗?", "提示", {
						type: "warning"
					})
					.then(() => {
						Technician.del({
							dynamicId: row.dynamicId
						}).then(data => {
							self.$message({
								message: "删除成功",
								type: "success"
							});
							self.loading = true;
							self.getTableList();
						});
					});
			},
			openFullScreen() {
				this.loading = true;
			},
			handleSelect(key) {
				this.formInline.status = key
				this.curPage = 1
				this.loading = true;
				this.getTableList();
			},
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.curPage = val;
				self.loading = true;
				self.getTableList();
			},

			/*每页多少条*/
			handleSizeChange(val) {
				this.curPage = 1;
				this.pageSize = val;
				this.getTableList();
			},

			/*获取列表*/
			getTableList() {
				let self = this;
				self.openFullScreen()
				let Params = self.formInline;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				Technician.Dynamic(Params, true)
					.then(data => {
						self.loading = false;
						self.tableData = data.data.lists.data;
						self.totalDataNumber = data.data.lists.total;
						self.extend = data.data.extend
					})
					.catch(error => {
						self.loading = false;
					});
			},

			/*搜索查询*/
			onSubmit() {
				let self = this;
				self.loading = true;
				let Params = self.formInline;
				self.getTableList();
			}
		}
	};
</script>
<style>
	.slider {
		overflow-x: auto;
		scroll-snap-type: x mandatory;
		white-space: nowrap;
	}

	.slides img {
		scroll-snap-align: start;
		display: inline-block;
		width: 100%;
	}

	.video-tag {
		min-height: 100px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.video-tag-item {
		width: 200px;
		margin: 20px;
		display: flex;
		flex-direction: column;
	}

	.video-tag-title {
		text-align: center;
		margin-top: 10px;
		font-size: 15px;
	}

	.video-tag-rich {
		margin-top: 6px;
		margin-bottom: 10px;
	}

	.video-tag-label {
		display: flex;
		align-items: center;
		margin-top: 10px;
	}

	.video-tag-center {
		display: flex;
		align-items: center;
		flex: 1;
		justify-content: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/dynamic/index.vue